import { notNil } from '../../core/helpers/is-nil';

type OptionBasic = {
  value: string;
  label: string;
};

type OptionWithColorSample = {
  value: string;
  label: string;
  colorSampleHexCode: string;
};

type OptionWithPicto = {
  value: string;
  label: string;
  pictoSrc: string;
};

export type ComboboxOptions = OptionBasic[] | OptionWithColorSample[] | OptionWithPicto[];

export const isOptionBasic = (value: unknown): value is OptionBasic => {
  return typeof value === 'object' && notNil(value) && 'label' in value && 'value' in value;
};

export const isOptionWithColorSample = (value: unknown): value is OptionWithColorSample => {
  return (
    typeof value === 'object' && notNil(value) && 'label' in value && 'value' in value && 'colorSampleHexCode' in value
  );
};

export const isOptionWithPicto = (value: unknown): value is OptionWithPicto => {
  return typeof value === 'object' && notNil(value) && 'label' in value && 'value' in value && 'pictoSrc' in value;
};

export const isComboboxOptions = (value: unknown): value is ComboboxOptions => {
  return (
    Array.isArray(value) &&
    (value.every(isOptionBasic) || value.every(isOptionWithColorSample) || value.every(isOptionWithPicto))
  );
};
